import { DEPTH_LEVELS } from '../api'
import { useT } from '../i18n'

/**
 * Горизонтальный глубиномер.
 *
 * Вертикальный «зонд» рисовал водную колонку красиво, но занимал треть высоты
 * панели, и разделы под ним не помещались на экран (фидбек владельца
 * 2026-08-07: «красивая штука, но не практичная — сделаем компактнее»).
 *
 * Шкала НЕ линейна по метрам: двигаемся по индексу уровня (DEPTH_LEVELS), иначе
 * рабочие 0–100 м сжались бы в четверть ползунка, а половину заняли бы 300–600 м,
 * куда почти не ходят.
 */
interface Props {
  depth: number
  onChange: (depth: number) => void
}

const N = DEPTH_LEVELS.length

export function DepthSliderCompact({ depth, onChange }: Props) {
  const t = useT()
  const idx = Math.max(0, DEPTH_LEVELS.indexOf(depth))

  return (
    <div className="rounded-lg border border-hull bg-trench px-3 py-2">
      <div className="mb-1.5 flex items-baseline gap-1">
        <span className="tnum text-xl font-bold leading-none text-foam">{depth}</span>
        <span className="text-xs font-medium text-sonar">{t('units.m')}</span>
        <span className="ml-auto text-[10px] text-faint">{t('maps.depth.horizonShort')}</span>
      </div>
      <input
        type="range"
        min={0}
        max={N - 1}
        step={1}
        value={idx}
        onChange={e => onChange(DEPTH_LEVELS[Number(e.target.value)])}
        aria-label={t('maps.depth.aria')}
        className="isotherm-range w-full"
      />
      <div className="mt-1 flex justify-between tnum text-[10px] text-mist">
        <span>{DEPTH_LEVELS[0]}</span>
        <span>{DEPTH_LEVELS[N - 1]} {t('units.m')}</span>
      </div>
    </div>
  )
}
